export default __webpack_public_path__ + "static/media/banner.76295f9c.gif";